import BaseState from '@state/BaseState'
import { Signals } from "@/Imports";
import GameStatesEnum from "../GameStatesEnum";
import Facade from "@/Facade";

export default class GetBuyFreespinResponseState extends BaseState {

  begin() {
    console.log('GetBuyFreespinResponseState')
    Signals.buyFreespinResponse.addOnce(this.onBuyFreespinResponse, this)
    Signals.buyFreespinsComplete.addOnce(this.onBuyFreespinsComplete, this)
    Signals.realityCheck.addOnce(this.onError, this)
    Signals.gameMessage.dispatch('buy_freebet')
  }

  onError(){
    this.model.isFreespinsStarted = false
    this.model.isFreespinsMode = false
    this.stateMachine.setState(GameStatesEnum.IDLE)
  }

  onBuyFreespinResponse = (data) => {
    this.model.spinRawData = data
    Signals.buyFreespinsNow.dispatch()
    this.end()
 //   this.model.isFreespinsStarted = true
 //   this.model.isFreespinsMode = true
///    Signals.buyFreespins.dispatch()
  }

  onBuyFreespinsComplete = () => {
    this.end()
  }

  end = () => {
   // this.model.isFreespinsStarted = true
   // this.model.isFreespinsMode = true
    Facade.model.session_total_bet += this.model.totalBetNumber
    Signals.startSpin.dispatch()
    this.stateMachine.setState(GameStatesEnum.SPIN_STOP)
  //  this.stateMachine.setState(GameStatesEnum.IDLE)  //FREE_SPINS_BUY) //FREE_SPINS_INTRO) //IDLE)
  }

  cleanUp() {
    Signals.buyFreespinResponse.remove(this.onBuyFreespinResponse, this)
  }
}
